<script>
// import dayjs from 'dayjs';
import Month from './Month';

const months = year => ([
  `${year}-01-01`,
  `${year}-02-01`,
  `${year}-03-01`,
  `${year}-04-01`,
  `${year}-05-01`,
  `${year}-06-01`,
  `${year}-07-01`,
  `${year}-08-01`,
  `${year}-09-01`,
  `${year}-10-01`,
  `${year}-11-01`,
  `${year}-12-01`,
]);

export default {
  name: 'WeekendsCalendar',
  props: {
    weekends: {
      type: Array,
      required: true,
    },
    year: {
      type: Number,
      required: true,
    },
    canEdit: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    const { year } = this;

    return {
      months: months(year),
    };
  },
  methods: {
    handleDatesUpdate (dates) {
      this.$emit('datesupdate', dates);
    },
  },
  render () {
    const { $style } = this;

    return (
      <div class={$style.calendar}>
        {this.months.map((m, i) => (
          <Month
            key={i}
            date={m}
            dates={this.weekends}
            canEdit={this.canEdit}
            onDatesupdate={this.handleDatesUpdate}
          />
        ))}
      </div>
    );
  },
};
</script>

<style lang="scss" module>
.calendar {
  display: grid;
  grid-gap: 1rem;
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(3, auto);
}
</style>
